import request from '@/utils/request'

export function updateCfg(data) {
  return request({
    url: 'api/v1/free-reward-config/update',
    method: 'post',
    data: data
  })
}

export function getList(data) {
  return request({
    url: 'api/v1/free-reward-config/getList',
    method: 'post',
    data: data
  })
}

export function delList(data) {
  return request({
    url: 'api/v1/free-reward-config/delete',
    method: 'delete',
    data: data
  })
}
